'use strict';

// Product Card
const cardAction = 1;
// Dropdown
const dropdown = 99;
// Tooltip and Popover
const tooltip = 9999;

exports.cardAction = cardAction;
exports.dropdown = dropdown;
exports.tooltip = tooltip;
//# sourceMappingURL=zIndex.cjs.map
